// See documentation on https://www.goodreads.com/style_guide

import React from "react";
import ReactDOM from "react-dom";
import GrComponentFactory from "../../gr_component_factory";
import CloseButton from "../../close_button";
import classnames from "classnames";
import { includes, isEqual, throttle } from "lodash";

export const POPOVER_ARROW_POSITIONS = {
  TOP_RIGHT: "topRight",
};
const POPOVER_ARROW_LENGTH_PX = 12;   // See $popover-arrow-height;

const POPOVER_TARGET_REF = "popoverTarget";
const POPOVER_CLASS_NAME = "gr-popover";

export default GrComponentFactory.createClass({
  displayName: "Popover",

  propTypes: {
    body: React.PropTypes.element.isRequired,
    onClose: React.PropTypes.func.isRequired,
    popoverTarget: React.PropTypes.element,
    headingText: React.PropTypes.string,
    isOpen: React.PropTypes.bool,
    showCloseButton: React.PropTypes.bool,
    showArrow: React.PropTypes.bool,
    // Unsupported for now; accepting arrowPosition prop will require adding
    // logic to position calculation
    //arrowPosition: React.PropTypes.oneOf(values(POPOVER_ARROW_POSITIONS))
  },

  getDefaultProps() {
    return {
      isOpen: false,
      isCloseOnOutsideClick: true,
      showArrow: true,
      showCloseButton: true,
      // Unsupported for now; accepting arrowPosition prop will require adding
      // logic to position calculation
      // arrowPosition: POPOVER_ARROW_POSITIONS.TOP_RIGHT
    };
  },

  getInitialState() {
    return {
      popoverPosition: null,
    };
  },


  componentDidUpdate() {
    if (this.props.popoverTarget) {
      const previousPosition = this.state.popoverPosition;
      const currentPosition = this.getPopoverPosition();
      if (!isEqual(previousPosition, currentPosition)) {
        this.resetPopoverPosition();
      }
    }
  },

  componentDidMount() {
    //reset popover position relative to the `props.popoverTarget` only when present.
    if (this.props.popoverTarget) {
      this.resetPopoverPosition();
      const onResizeThrottled = throttle(this.resetPopoverPosition, 10);
      window.addEventListener("resize", onResizeThrottled);
    }
  },

  hasTopArrow() {
    return this.props.showArrow &&
              includes([POPOVER_ARROW_POSITIONS.TOP_LEFT],
                       this.props.arrowPosition);
  },

  getPopoverTargetBoundingClientRect() {
    const popoverTarget = ReactDOM.findDOMNode(this.refs[POPOVER_TARGET_REF]);
    if (popoverTarget) {
      return popoverTarget.getBoundingClientRect();
    }
  },

  getPopoverPositionTop() {
    const popoverTargetClientRect = this.getPopoverTargetBoundingClientRect();
    if (popoverTargetClientRect) {
      if (this.hasTopArrow()) {
        return popoverTargetClientRect.height + POPOVER_ARROW_LENGTH_PX;
      } else {
        return popoverTargetClientRect.height;
      }
    } else {
      if (this.hasTopArrow()) {
        return POPOVER_ARROW_LENGTH_PX;
      } else {
        return 0;
      }
    }
  },

  getPopoverPosition() {
    const popoverTargetClientRect = this.getPopoverTargetBoundingClientRect();
    if (popoverTargetClientRect) {
      // Both the Popover and its target are supposed to be inside a positioned
      // wrapper (e.g., a <div> with `position:relative`) so that we can use
      // `position: absolute` to make the popover appear on top of page content
      // and slightly offset from the target. We use the target's "bounding
      // rectangle" to figure out how much space it takes up, and therefore
      // where to position the popover within the positioned wrapper.
      //
      // For now, we put the popover below the target. In the future, we could
      // complicate this function to allow it to appear in a different place,
      // e.g., above the target.
      return {
        right: 0,
        top: this.getPopoverPositionTop(),
      };
    } else {
      return null;
    }
  },

  resetPopoverPosition() {
    this.setState({
      popoverPosition: this.getPopoverPosition(),
    });
  },

  onClose() {
    this.props.onClose();
  },

  renderCloseAction() {
    if (this.props.showCloseButton) {
      return <div className="u-floatRight">
        <CloseButton action={this.onClose}/>
      </div>;
    }
  },

  renderHeader() {
    const headingText = this.props.headingText;
    if (headingText) {
      return <h3 className="gr-h3 gr-h3--noTopMargin">{headingText}</h3>;
    }
  },

  renderArrow() {
    if (this.props.showArrow) {
      const arrowPositionClass =
        `${POPOVER_CLASS_NAME}__arrow--${POPOVER_ARROW_POSITIONS.TOP_RIGHT}`;
      const arrowClassNames = classnames(`${POPOVER_CLASS_NAME}__arrow`, arrowPositionClass);
      return <div className={arrowClassNames} />;
    }
  },

  renderPopover() {
    if (this.props.isOpen) {
      const popoverStyle = {};
      if (this.state.popoverPosition) {
        popoverStyle.top = this.state.popoverPosition.top;
        popoverStyle.right = this.state.popoverPosition.right;
      }

      return <div style={popoverStyle} className={this.withBemModifiers(POPOVER_CLASS_NAME)}>
        {this.renderArrow()}
        {this.renderCloseAction()}
        {this.renderHeader()}
        {this.props.body}
      </div>;
    }
  },

  renderPopoverTarget() {
    if (this.props.popoverTarget) {
      return React.cloneElement(this.props.popoverTarget, {
        ref: POPOVER_TARGET_REF,
      });
    }
  },

  render() {
    return <div className="u-positionRelative">
      {this.renderPopoverTarget()}
      {this.renderPopover()}
    </div>;
  },
});
